export default __webpack_public_path__ + "static/media/spring.527efbd6.svg";